import client from 'api/client';

export function get(serviceName: string) {
    return client.get(`/service_paid/${serviceName}`);
}
